import { render, staticRenderFns } from "./PatientDrug.vue?vue&type=template&id=8f3d5954&scoped=true"
import script from "./PatientDrug.vue?vue&type=script&lang=js"
export * from "./PatientDrug.vue?vue&type=script&lang=js"
import style0 from "./PatientDrug.vue?vue&type=style&index=0&id=8f3d5954&prod&scoped=true&lang=css"
import style1 from "./PatientDrug.vue?vue&type=style&index=1&id=8f3d5954&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f3d5954",
  null
  
)

export default component.exports